<template>
    <div>
        <div class="row">
            <div class="col-sm-12 col-md-12">
                <tabs>
                    <tab :nameTab="__('Shipments report')" :selected="true">
                        <ReportLoads/>
                    </tab>

                    <tab :nameTab="__('Release report')">
                        <ReportSells/>
                    </tab>
                </tabs>
            </div>
        </div>
    </div>
</template>

<script>
import Tabs from '../Tabs/Tabs'
import Tab from '../Tabs/Tab'
import ReportLoads from './ReportLoads'
import ReportPayments from './ReportPayments'
import ReportSells from './ReportSells'

export default {
  name: 'Reports',

  components: {
    ReportSells,
    ReportPayments,
    ReportLoads,
    Tabs,
    Tab
  }
}
</script>
